import React, { useState, useEffect, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { currentRouteSet } from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { pathSpliter, dateTimeFormat, currentDateStartTime, currentDateEndTime } from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import { API_URL } from '../../config';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import PrintIcon from '@material-ui/icons/Print';
import { NetworkLoaderOverlay } from "../commons/NetworkLoader";
import '../commons/commons.css'


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import InstitutionProfile from '../commons/institution_profile'
import ReactToPrint from "react-to-print";
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')
const ProductLedger = ({ location, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const [floors, floorsSet] = useState([]);
  const [allProducts, allProductsSet] = useState([]);
  const [floorProducts, floorProductsSet] = useState([]);
  const [selectedFloor, selectedFloorSet] = useState(null);
  const [selectedProductGroup, selectedProductGroupSet] = useState(null);
  const [selectedBrand, selectedBrandSet] = useState(null);
  const [report, reportSet] = useState([]);
  const [print, printSet] = useState(false);
  const [reportLoading, reportLoadingSet] = useState(false);
  const [floorProductsLoading, floorProductsLoadingSet] = useState(false);
  const [opening_stock, opening_stock_set] = useState(0);
  const [closing_stock, closing_stock_set] = useState(0);
  const [byDateTime, byDateTimeSet] = useState({
    fromDate: currentDateStartTime(),
    toDate: currentDateEndTime()
  });

  const floorProductsEndpointAvailableRef = useRef(true);
  const productLocationCacheRef = useRef({});
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const searchButtonRef = useRef(null);
  const reportRef = useRef(null);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getFloors();
    getProducts();
  }, []);

  const fmtAmount = (value) => format(Number(parseFloat(value || 0)).toFixed(2));
  const fmtDate = (value) => value ? moment(value).format(dateTimeFormat) : '-';

  const normalizeLabel = (value) => String(value || '').trim().toLowerCase();

  const uniqueProductGroups = useMemo(() => {
    const grouped = new Map();

    (floorProducts || []).forEach((product) => {
      const key = normalizeLabel(product?.prod_name);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, {
          prod_name: product.prod_name,
          prod_code: product.prod_code || '',
          prod_color_name: product.prod_color_name || '',
          products: [product],
        });
      } else {
        grouped.get(key).products.push(product);
      }
    });

    return Array.from(grouped.values()).sort((left, right) =>
      String(left?.prod_name || '').localeCompare(String(right?.prod_name || ''))
    );
  }, [floorProducts]);

  const availableBrands = useMemo(() => {
    const brands = new Map();

    (selectedProductGroup?.products || []).forEach((product) => {
      const brandKey = normalizeLabel(product?.prod_brand_name || 'Unspecified');
      if (!brands.has(brandKey)) {
        brands.set(brandKey, {
          prod_brand_id: product?.prod_brand_id || 0,
          prod_brand_name: product?.prod_brand_name || 'Unspecified',
          product,
        });
      }
    });

    return Array.from(brands.values()).sort((left, right) =>
      String(left?.prod_brand_name || '').localeCompare(String(right?.prod_brand_name || ''))
    );
  }, [selectedProductGroup]);

  const resolvedProduct = useMemo(() => {
    if (selectedBrand?.product) return selectedBrand.product;
    if (selectedProductGroup?.products?.length) return selectedProductGroup.products[0];
    return null;
  }, [selectedBrand, selectedProductGroup]);

  const getFloors = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-floors`,
        null,
        { headers: { 'auth-token': authInfo.token } }
      );
      const nextFloors = Array.isArray(response?.data?.message) ? response.data.message : [];
      floorsSet([{ prod_floor_id: 'all', prod_floor_name: 'All Floor' }, ...nextFloors]);
    } catch (_err) {
      floorsSet([{ prod_floor_id: 'all', prod_floor_name: 'All Floor' }]);
    }
  };

  const getProducts = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-products`,
        { 'select-type': 'active' },
        { headers: { 'auth-token': authInfo.token } }
      );
      allProductsSet(Array.isArray(response?.data?.message) ? response.data.message : []);
    } catch (_err) {
      allProductsSet([]);
    }
  };

  const getProductLocations = async (productId) => {
    if (!productId) return [];
    if (productId in productLocationCacheRef.current) {
      return productLocationCacheRef.current[productId];
    }

    try {
      const response = await axios.post(
        `${API_URL}/api/get-product-location`,
        { productId },
        { headers: { 'auth-token': authInfo.token } }
      );
      const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
      productLocationCacheRef.current[productId] = rows;
      return rows;
    } catch (_err) {
      productLocationCacheRef.current[productId] = [];
      return [];
    }
  };

  const loadFloorProducts = async (floorItem) => {
    if (!floorItem?.prod_floor_id) {
      floorProductsSet([]);
      return;
    }

    if (String(floorItem.prod_floor_id) === 'all') {
      floorProductsSet(Array.isArray(allProducts) ? allProducts : []);
      return;
    }

    floorProductsLoadingSet(true);
    try {
      const floorId = Number(floorItem.prod_floor_id);
      let matchedProducts = [];

      if (floorProductsEndpointAvailableRef.current) {
        try {
          const response = await axios.post(
            `${API_URL}/api/get-floor-products`,
            { floorId },
            { headers: { 'auth-token': authInfo.token } }
          );
          matchedProducts = Array.isArray(response?.data?.message) ? response.data.message : [];
        } catch (error) {
          if (error?.response?.status === 404) {
            floorProductsEndpointAvailableRef.current = false;
          } else {
            throw error;
          }
        }
      }

      if (!floorProductsEndpointAvailableRef.current) {
        const filtered = [];
        for (const product of allProducts) {
          const locations = await getProductLocations(product?.prod_id);
          const foundOnFloor = locations.some(
            (row) => Number(row?.prod_floor_id || 0) === floorId
          );
          if (foundOnFloor) filtered.push(product);
        }
        matchedProducts = filtered;
      }

      floorProductsSet(Array.isArray(matchedProducts) ? matchedProducts : []);
    } catch (_err) {
      floorProductsSet([]);
    } finally {
      floorProductsLoadingSet(false);
    }
  };

  useEffect(() => {
    selectedProductGroupSet(null);
    selectedBrandSet(null);
    reportSet([]);
    printSet(false);

    if (!selectedFloor?.prod_floor_id) {
      floorProductsSet([]);
      return;
    }

    loadFloorProducts(selectedFloor);
  }, [selectedFloor, allProducts]);

  useEffect(() => {
    selectedBrandSet(null);
    reportSet([]);
    printSet(false);
  }, [selectedProductGroup]);

  const getSearchResult = async () => {
    if (selectedFloor == null) {
      swal({ title: 'Select Floor', icon: 'warning' });
      return false;
    }
    if (selectedProductGroup == null) {
      swal({ title: 'Select Product', icon: 'warning' });
      return false;
    }
    if (selectedBrand == null) {
      swal({ title: 'Select Brand', icon: 'warning' });
      return false;
    }

    const payload = {
      productId: resolvedProduct?.prod_id || null,
      floorId: String(selectedFloor?.prod_floor_id) === 'all'
        ? null
        : selectedFloor?.prod_floor_id || null,
      brandId: selectedBrand?.prod_brand_id || null,
      brandName: selectedBrand?.prod_brand_name || '',
      fromDate: byDateTime.fromDate,
      toDate: byDateTime.toDate
    };

    reportLoadingSet(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/get-product-ledger`,
        { ...payload },
        { headers: { 'auth-token': authInfo.token } }
      );
      reportSet(Array.isArray(response?.data?.ledger) ? response.data.ledger : []);
      opening_stock_set(Number(response?.data?.opening_stock || 0));
      closing_stock_set(Number(response?.data?.closing_stock || 0));
      printSet(true);
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Unknown error';
      swal({ title: 'Failed to load ledger', text: backendMessage, icon: 'error' });
      reportSet([]);
      printSet(false);
    } finally {
      reportLoadingSet(false);
    }
  };


  let ReportDom = React.forwardRef((props, ref) => {
    const floorName = selectedFloor?.prod_floor_name || '';
    const productName = selectedProductGroup?.prod_name || '';
    const brandName = selectedBrand?.prod_brand_name || '';
    const startDateLabel = moment(byDateTime.fromDate).format(dateTimeFormat);
    const endDateLabel = moment(byDateTime.toDate).format(dateTimeFormat);

    return (<div ref={ref}>
      <InstitutionProfile />

      <div style={{ clear: 'both' }}></div>
      <Paper style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }} className="print-source">
        <p style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>Product Ledger</p>

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap', fontSize: '16px' }}>
          <p style={{ margin: 0, padding: 0 }}>{`Floor : ${floorName}`}</p>
          <p style={{ margin: 0, padding: 0 }}>{`Product : ${productName}`}</p>
          <p style={{ margin: 0, padding: 0 }}>{`Brand : ${brandName}`}</p>
          <p style={{ margin: 0, padding: 0 }}>{`Start Date : ${startDateLabel}`}</p>
          <p style={{ margin: 0, padding: 0 }}>{`End Date : ${endDateLabel}`}</p>
        </div>
      </Paper>

      {
        print ? (
          <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >


            <TableContainer >
              <Table className={`${classes.table} report-dom`} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Voucher No</TableCell>
                    <TableCell align="left">Customer / Supplier</TableCell>
                    <TableCell align="right">Purchase Rate</TableCell>
                    <TableCell align="right">Sale Rate</TableCell>
                    <TableCell align="right">Stock In</TableCell>
                    <TableCell align="right">Stock Out</TableCell>
                    <TableCell align="right">Balance Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  <TableRow key="">
                    <TableCell colSpan={2}></TableCell>
                    <TableCell style={{ color: '#005400', fontWeight: 'bold' }}>Opening Stock</TableCell>
                    <TableCell colSpan={4}></TableCell>
                    <TableCell style={{ color: '#005400', fontWeight: 'bold' }} align="right">{fmtAmount(opening_stock)}</TableCell>
                  </TableRow>


                  {
                    report.length > 0 ? report.map((row, sl) => (
                      <TableRow key={`${row?.sequence || 'r'}-${row?.id || sl}-${sl}`}>
                        <TableCell align="left">{fmtDate(row.dateTime)}</TableCell>
                        <TableCell align="left">{row.voucher_no || row.voucherNo || '-'}</TableCell>
                        <TableCell align="left">{row.party_name || row.partyName || row.customer_name || row.supplier_name || '-'}</TableCell>
                        <TableCell align="right">{fmtAmount(row.purchase_rate || row.pur_rate || 0)}</TableCell>
                        <TableCell align="right">{fmtAmount(row.sale_rate || row.rate || 0)}</TableCell>
                        <TableCell align="right">{fmtAmount(row.in_qty || 0)}</TableCell>
                        <TableCell align="right">{fmtAmount(row.out_qty || 0)}</TableCell>
                        <TableCell align="right">{fmtAmount(row.stock || 0)}</TableCell>
                      </TableRow>
                    )) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          No ledger data found for the selected filters.
                        </TableCell>
                      </TableRow>
                    )
                  }

                  <TableRow style={{ background: '#f1f1f1' }}>
                    <TableCell colSpan={5} align="right">Total</TableCell>
                    <TableCell align="right">{fmtAmount(report.reduce((prev, curr) => { return prev + Number(curr?.in_qty || 0) }, 0))}</TableCell>
                    <TableCell align="right">{fmtAmount(report.reduce((prev, curr) => { return prev + Number(curr?.out_qty || 0) }, 0))}</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>


                  <TableRow key="" >
                    <TableCell colSpan={7} align="right" style={{ color: '#005400', fontWeight: 'bold' }} >Closing Stock</TableCell>
                    <TableCell style={{ color: '#005400', fontWeight: 'bold' }} align="right">{fmtAmount(closing_stock)}</TableCell>
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        ) : ''
      }
    </div>)
  })

  return (
    <div className={classes.root}>
      <NetworkLoaderOverlay visible={reportLoading} message="Loading report..." />
      <Paper className={classes.paper} style={{ marginTop: '-25px', marginBottom: '5px' }}>
        <h4 style={{
          textAlign: 'left', margin: 0, padding: 0, marginTop: '-10px',
          marginBottom: '2px'
        }}>Product Ledger</h4>



        <Grid container spacing={3} >

          <Grid item xs={12} sm={2} >
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus={true}
              style={{ width: '100%', height: '20px' }}
              options={floors}
              value={selectedFloor}
              getOptionLabel={(option) => option?.prod_floor_name ?? ""}
              getOptionSelected={(option, value) => option?.prod_floor_id === value?.prod_floor_id}
              onChange={(event, selectedObj) => {
                selectedFloorSet(selectedObj)
              }}
              renderInput={(params) => <TextField
                {...params}
                label="Floor"
                variant="outlined"
              />}
            />
          </Grid>

          <Grid item xs={12} sm={2} >
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus={true}
              style={{ width: '100%', height: '20px' }}
              options={uniqueProductGroups}
              value={selectedProductGroup}
              disabled={!selectedFloor || floorProductsLoading}
              getOptionLabel={(option) => `${option?.prod_code ? `${option.prod_code} - ` : ''}${option?.prod_name ?? ''}`.trim()}
              onChange={(event, selectedObj) => {
                selectedProductGroupSet(selectedObj)
              }}
              loading={floorProductsLoading}
              renderInput={(params) => <TextField
                {...params}
                label="Product"
                variant="outlined"
              />}
            />
          </Grid>

          <Grid item xs={12} sm={2} >
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus={true}
              style={{ width: '100%', height: '20px' }}
              options={availableBrands}
              value={selectedBrand}
              disabled={!selectedProductGroup}
              getOptionLabel={(option) => option?.prod_brand_name ?? ""}
              onChange={(event, selectedObj) => {
                selectedBrandSet(selectedObj)
              }}
              renderInput={(params) => <TextField
                {...params}
                label="Brand"
                variant="outlined"
              />}
            />
          </Grid>

          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                inputRef={fromDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    toDateRef.current?.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.fromDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, fromDate: datet })
                }}
                label="From Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>


          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                inputRef={toDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    searchButtonRef.current?.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.toDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, toDate: datet })

                }}
                label="To Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={1} >
            <Button style={{ marginTop: '5px', marginLeft: 'auto', fontSize: '14px' }}
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<SearchIcon />}
              onClick={getSearchResult}
              disabled={reportLoading ? true : false}
              ref={searchButtonRef}
            >
              Search
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {
        print ? (
          <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{ borderRadius: '0px', marginTop: '-7px' }}>
                <ReactToPrint
                  trigger={() => <PrintIcon style={{ cursor: 'pointer', marginLeft: '30px', marginTop: '3px', marginBottom: '-8px' }} />}
                  content={() => reportRef.current}
                />
              </Paper>

            </Grid>
          </Grid>
        ) : ''
      }

      <ReportDom ref={reportRef} />
    </div>

  )
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: '100%',
    marginTop: '5px'
  },
  plusLinkDiv: {
    position: 'relative'
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer
  }
}
export default connect(mapStateToPops, { currentRouteSet })(ProductLedger);
